export default function loadTradeform() {
  const tradeForm = document.querySelector('#tradeForm'),
    formsHeader = document.querySelector('.forms-header'),
    submitButton = tradeForm.querySelector('#tradeSubmit'),
    instructions = formsHeader.querySelector('.instructions'),
    thankYou = formsHeader.querySelector('.thank-you');

  /* Account Type Selection */
  const tradeButton = tradeForm.querySelector("[data-toggle-value='trade']"),
    hospButton = tradeForm.querySelector("[data-toggle-value='hospitality']"),
    tradeCopy = tradeForm.querySelector("[data-toggle-group='trade']"),
    hospCopy = tradeForm.querySelector("[data-toggle-group='hospitality']");

  tradeButton.addEventListener('click', () => {
    tradeCopy.classList.remove('hide');
    hospCopy.classList.add('hide');
  });

  hospButton.addEventListener('click', () => {
    hospCopy.classList.remove('hide');
    tradeCopy.classList.add('hide');
  });

  /* Spam Detection Helpers */
  const isLikelyGibberish = (text) => {
    if (!text || text.length < 3) return false;

    // Normalize text for checking
    const normalizedText = text.trim();

    // Check for excessive consonant clusters (e.g., "qubMFnIYhL")
    const consonantClusters = normalizedText.match(
      /[bcdfghjklmnpqrstvwxyz]{7,}/gi
    );
    if (consonantClusters && consonantClusters.length > 0) return true;

    // Check for alternating case without spaces (common in spam like "qubMFnIYhL")
    const hasMultipleCaseChanges = /[a-z][A-Z].*[a-z][A-Z]/.test(
      normalizedText
    );
    if (hasMultipleCaseChanges && !normalizedText.includes(' ')) return true;

    // Check vowel ratio (real text usually has 35-45% vowels)
    const vowels = (normalizedText.match(/[aeiou]/gi) || []).length;
    const vowelRatio = vowels / normalizedText.length;
    if (vowelRatio < 0.2 || vowelRatio > 0.7) return true;

    return false;
  };

  const shouldContainSpaces = (name, value) => {
    // These fields should contain spaces if they're longer than 20 characters
    const fieldsNeedingSpaces = [
      'CompanyName',
      'CompanyAddressLine1',
      'CompanyAddressLine2',
    ];
    return (
      fieldsNeedingSpaces.includes(name) &&
      value.length > 20 &&
      !value.includes(' ')
    );
  };

  submitButton.addEventListener('click', async (e) => {
    e.preventDefault();

    // Prevent multiple submissions by disabling button immediately
    if (submitButton.disabled) {
      return;
    }

    /* Honeypot Check - if filled, this is likely a bot */
    const honeypot = tradeForm.querySelector('#website_url');
    if (honeypot && honeypot.value !== '') {
      // Silently fail - don't give feedback to bot
      return;
    }

    /* Text input Required Validation */
    const textInputs = document.querySelectorAll("input[type='text']");
    const requiredInputs = Array.from(textInputs).filter((elem) =>
      elem.matches('[required]')
    );

    for (const elem of requiredInputs) {
      elem.value == ''
        ? elem.classList.add('invalid')
        : elem.classList.remove('invalid');
    }

    /* Gibberish Detection */
    // Skip gibberish detection for fields with specific formats (email, phone, URLs, addresses with abbreviations)
    const skipGibberishCheck = [
      'EmailAddress',
      'PhoneNumber',
      'CompanyLinksLine1',
      'CompanyLinksLine2',
      'CompanyAddressLine1',
      'CompanyAddressLine2',
    ];

    for (const elem of requiredInputs) {
      // Skip fields that have specific formats
      if (skipGibberishCheck.includes(elem.name)) continue;

      const value = elem.value.trim();
      if (
        value &&
        (isLikelyGibberish(value) || shouldContainSpaces(elem.name, value))
      ) {
        elem.classList.add('invalid');
      }
    }

    let is_valid = null;
    const invalidExists = tradeForm.querySelectorAll('.invalid').length > 0;

    is_valid = invalidExists ? false : true;

    // Show message if gibberish was detected
    if (!is_valid && tradeForm.querySelectorAll('.invalid').length > 0) {
      const hasGibberish = Array.from(
        tradeForm.querySelectorAll('.invalid')
      ).some((elem) => {
        // Skip fields with specific formats
        if (skipGibberishCheck.includes(elem.name)) return false;

        const value = elem.value.trim();
        return (
          value &&
          (isLikelyGibberish(value) || shouldContainSpaces(elem.name, value))
        );
      });

      if (hasGibberish) {
        alert(
          'Please enter valid information in all fields. Some entries appear to be invalid.'
        );
      }
    }

    if (is_valid == true) {
      // Disable submit button and show loading state
      submitButton.disabled = true;
      const originalButtonText = submitButton.textContent.trim();
      submitButton.textContent = 'Submitting...';

      // Force a microtask to allow rendering
      await new Promise((resolve) => setTimeout(resolve, 0));

      /* GET DATA FROM CHECKBOXES AND RADIO BUTTONS */
      let checkedDataStr = '';

      const getCheckedData = (inputName) => {
        const checkedInputs = document.querySelectorAll(
          `input[name="${inputName}"]:checked`
        );
        const checkedArr = [...checkedInputs].map((input) => input.value);
        let checkedStr = '';

        /*
         * If the input is a radio button or i suppose a checkbox with only one
         * option, then don't add a comma, otherwise do.
         */
        for (const [i, value] of checkedArr.entries()) {
          checkedStr =
            i === 0 ? (checkedStr += value) : (checkedStr += `,${value}`);
        }

        /* Add the input name so data goes to the correct google sheet column */
        const checkedData = `&${inputName}=` + encodeURIComponent(checkedStr);
        checkedDataStr += checkedData;

        return checkedDataStr;
      };

      /* Supply the checkboxes and radio button names */
      const checkedInputs = [
        'HearAboutUs',
        'ProductScope',
        'TaxExempt',
        'accountType',
      ];
      for (const inputName of checkedInputs) {
        getCheckedData(inputName);
      }

      /* GET DATA FROM TEXT INPUTS */
      /* go through each input and pair the name with the value */
      const getTextData = (input) => {
        const textInputStr =
          `&${input.name}=` + encodeURIComponent(`${input.value}`);
        return textInputStr;
      };

      const textInputs = document.querySelectorAll("input[type='text']");
      // Exclude honeypot field from serialization
      const textInputArr = [...textInputs]
        .filter((input) => input.id !== 'website_url')
        .map((input) => getTextData(input));
      let textDataStr = '';

      /* go through each input name/input value pair and concatenate them */
      for (const textInput of textInputArr) {
        textDataStr += textInput;
      }

      const serializedData = textDataStr + checkedDataStr;
      // console.log(serializedData);

      /*
       * Let's disable the inputs for the duration of the Ajax request.
       * Note: we disable elements AFTER the form data has been serialized.
       * Disabled form elements will not be serialized.
       * url: "https://script.google.com/macros/s/AKfycbzhig8jrw3xhKSzuCfAIlEZuaMvKMJXJVCMqblExO5WklQtCWp12PII2SN4Yu0saS0/exec",
       */
      const inputs = tradeForm.querySelectorAll('input');
      for (const input of inputs) {
        input.setAttribute('disabled', '');
      }

      /*
       * https://www.youtube.com/watch?v=fGYQJAlLD68
       * form data must get passed as x-www-form-urlencoded
       *
       * application/x-www-form-urlencoded: the keys and values are encoded in
       * key-value tuples separated by '&', with a '=' between the key and the
       * value.
       */

      const scriptURL =
        'https://script.google.com/macros/s/AKfycbzhig8jrw3xhKSzuCfAIlEZuaMvKMJXJVCMqblExO5WklQtCWp12PII2SN4Yu0saS0/exec';
      fetch(scriptURL, {
        method: 'POST',
        body: serializedData,
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      })
        .then((response) => {
          // Check if response is ok before proceeding
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }

          // Check content type to ensure we're not getting HTML
          const contentType = response.headers.get('content-type');
          if (contentType && contentType.includes('text/html')) {
            throw new Error(
              'Received HTML response instead of expected format'
            );
          }

          return response;
        })
        .then(() => {
          /* Reenable the inputs */
          const inputs = tradeForm.querySelectorAll('input');
          for (const input of inputs) {
            input.removeAttribute('disabled');
          }
          /* Send tracking of submit to GTM */
          window.dataLayer.push({ event: 'dl_corporate_gifting_form_submit' });
          /* Hide the form */
          tradeForm.style.display = 'none';
          instructions.style.display = 'none';
          thankYou.style.display = 'block';
          // Button stays disabled since form is hidden on success
        })
        .catch((error) => {
          /* Re-enable the inputs on error */
          const inputs = tradeForm.querySelectorAll('input');
          for (const input of inputs) {
            input.removeAttribute('disabled');
          }

          /* Re-enable the submit button and restore text */
          submitButton.disabled = false;
          submitButton.textContent = originalButtonText;

          throw new Error(`Form submission failed. ${error}`);
        });
    }
  });
}
